export enum MethodOfPayment {
  Payment_Gateway = 'Payment Gateway',
  Bank_Transfer = 'Bank Transfer',
  NEFT = 'NEFT',
  RTGS = 'RTGS',
  Cheque = 'Cheque',
  Other_Instruments = 'Other Instruments',
}
